import React, { useEffect, useState } from "react";
import FilterMenuOptions from "../FilterUtils/FilterMenuOptions";

interface IMenuOptionProps {
  uid: string;
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: (type: string, option: string, uid: string) => void;
  filterFieldData: React.MutableRefObject<{
    dataType: string;
    filterType: string;
    shouldExclude: boolean;
  }>;
}

const MenuOption = ({
  uid,
  open,
  anchorEl,
  onClose,
  filterFieldData,
}: IMenuOptionProps) => {
  const [selectedOption, setSelectedOption] = useState<string>("");
  function toCamelCase(str: string) {
    return str
      .toLowerCase()
      .split(/[\s-_]+/) // Split the string by spaces, dashes, or underscores
      .map((word: string, index: number) => {
        if (index === 0) {
          return word; // Leave the first word in lowercase
        }
        return word.charAt(0).toUpperCase() + word.slice(1); // Capitalize the first letter of the rest
      })
      .join(""); // Join the words back into a single string
  }
  const includeExcludeOptions = ["Include", "Exclude"];
  let filterOptions = ["Pick List", "Search Condition"];

  if (
    filterFieldData.current.dataType === 'timestamp' ||
    filterFieldData.current.dataType === 'date'
  ) {
    filterOptions = ["Pick List", "Search Condition", "Relative Filter",];
  }
  useEffect(() => {
    filterOptions.forEach((opt) => {
      if (toCamelCase(opt) === filterFieldData.current.filterType) {
        setSelectedOption(opt);
      }
    });

  }, []);

  const handleOptionClick = (section: string, value: string) => {
    const camelValue = section === "opt2" ? toCamelCase(value) : value;
    onClose(section, camelValue, uid);
  };

 

  return (
    <FilterMenuOptions
      anchorEl={anchorEl}
      open={open}
      onClose={() => onClose("clickOutside", "", uid)}
      includeExcludeOptions={includeExcludeOptions}
      filterOptions={filterOptions}
      selectedOption={selectedOption}
      includeExcludeValue={
        filterFieldData.current.shouldExclude ? "Exclude" : "Include"
      }
      filterType={selectedOption}
      onOptionClick={handleOptionClick}
    />
  );
};

export default MenuOption;
